const aspects = [
  "NEUROLOGICAL",
  "PSYCHOLOGICAL",
  "PHYSIOLOGICAL",
  "PEDAGOGICAL",
  "GENERIC",
];

export default aspects;
